function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Spin, Select, Divider, Space, Tag, Upload } from "antd";
import { Eyedropper, Upload as UploadIc } from 'react-bootstrap-icons';
import Common from "../includes/Common";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;

var LaboForm = function LaboForm(_ref) {
  var laboratory_result_id = _ref.laboratory_result_id,
      queue_item = _ref.queue_item,
      queue_item_element = _ref.queue_item_element,
      business_account_medical_item = _ref.business_account_medical_item,
      customer = _ref.customer,
      handler = _ref.handler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormProcessing = _useState2[0],
      setIsFormProcessing = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      successMessage = _useState4[0],
      setSuccessMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      errorMessage = _useState6[0],
      setErrorMessage = _useState6[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      atFile = _useState8[0],
      setAtFile = _useState8[1];

  var _useState9 = useState(queue_item_element && queue_item_element.laboratory_result ? queue_item_element.laboratory_result.result_string : ''),
      _useState10 = _slicedToArray(_useState9, 2),
      resultString = _useState10[0],
      setResultString = _useState10[1];

  var props = {
    onRemove: function onRemove(file) {
      setAtFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setAtFile(file);
      return false;
    },
    accept: ".png,.jpg,.jpeg,.pdf,.doc,.docx",
    maxCount: 1
  };

  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setSuccessMessage('');
    setErrorMessage('');
    var fd = new FormData();
    fd.append('laboratory_result_id', laboratory_result_id);
    fd.append('result_string', resultString);
    fd.append('business_account_medical_item_id', business_account_medical_item.id.toString());
    fd.append('normal_value', values.normal_value);
    fd.append('attached_file', atFile);
    fd.append('user_id', Common.currentUser.id);
    fd.append('customer_id', customer.id.toString());
    fd.append('queue_item_element_id', queue_item_element.id.toString());
    fd.append('queue_item_id', queue_item.id.toString());
    axios.post(Common.baseApiUrl + 'setlaboresult', fd).then(function (response) {
      setIsFormProcessing(false);

      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormProcessing(false);
      setErrorMessage('Une erreur est survenue');
    });
  };

  useEffect(function () {
    if (queue_item_element.laboratory_result != null) form.setFieldsValue({
      result_string: queue_item_element.laboratory_result.result_string,
      normal_value: queue_item_element.laboratory_result.normal_value
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "cool-radius",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
        children: [/*#__PURE__*/_jsx(Eyedropper, {
          size: 30
        }), "SAISIR LE RESULTAT DU LABORATOIRE"]
      }), /*#__PURE__*/_jsx(Tag, {
        color: "#f50",
        children: /*#__PURE__*/_jsx("b", {
          children: business_account_medical_item.label
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "success",
        message: successMessage
      }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: errorMessage
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Form, {
        form: form,
        onFinish: onFinish,
        layout: "vertical",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "result_string",
          label: "Resultat",
          children: /*#__PURE__*/_jsx(ReactQuill, {
            theme: "snow",
            value: resultString,
            onChange: setResultString
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Norme",
          name: "normal_value",
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsxs(Form.Item, {
          children: [/*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
            children: /*#__PURE__*/_jsx(Button, {
              icon: /*#__PURE__*/_jsx(UploadIc, {
                size: 20
              }),
              children: /*#__PURE__*/_jsx("b", {
                children: " Joindre un fichier"
              })
            })
          })), /*#__PURE__*/_jsx("br", {})]
        }), /*#__PURE__*/_jsx(Space, {
          direction: "horizontal",
          children: /*#__PURE__*/_jsx(Form.Item, {
            children: /*#__PURE__*/_jsx(Button, {
              loading: isFormProcessing,
              type: "primary",
              htmlType: "submit",
              children: /*#__PURE__*/_jsx("b", {
                children: " Sauvegarder"
              })
            })
          })
        })]
      })]
    })
  });
};

export default LaboForm;